import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { Card, CardBody } from '@react/react-spectrum/Card'
import Well from '@react/react-spectrum/Well'
import Heading from '@react/react-spectrum/Heading'
import CountUp from 'react-countup'
import LocaleCurrency from 'locale-currency'
import getSymbolFromCurrency from 'currency-symbol-map'
import 'react-circular-progressbar/dist/styles.css'

import { RootContext } from '../../../root/RootContext'
import { ProfileContext } from '../../../root/ProfileContext'
import './ActivitySummary.scss'
import { EE } from '../../../config/constants'

export default function ActivitySummary({ meta, content}) {
  const profileContext = useContext(ProfileContext)
  const { project } = useContext(RootContext)
  const currentProfile = profileContext.state.currentProfile
  const locale = project.meta.locale
  const currencyCode = LocaleCurrency.getCurrency(locale)
  const currencySymbol = getSymbolFromCurrency(currencyCode)

  const productViews = currentProfile?.experienceEvents?.filter((event) => event.entity.eventType == EE.PRODUCT_VIEW)
  const purchases = currentProfile?.experienceEvents?.filter((event) => event.entity.eventType == EE.CHECKOUT)

  const orderedPurchase = purchases?.sort((a, b) => b.timestamp - a.timestamp)
  const lastPurchase = orderedPurchase?.length > 0 ? orderedPurchase[0] : 0

  const totalPurchases = purchases?.reduce((acc, val) => {
    return parseFloat(acc) + parseFloat(val.entity?.productListItems?.reduce((prev, cur) => prev + cur.priceTotal, 0))
  }, 0)

  return (
    <div className='profile-module activity-summary'>
      <div className='module-content'>
        {currentProfile && currentProfile.experienceEvents && (
          <>
            {content.description && <Well>{content.description}</Well>}
            <KPI label='NET PURCHASES' value={totalPurchases} suffix={currencySymbol} />
            <KPI
              label='LAST PURCHASE'
              value={
                parseFloat(lastPurchase?.entity?.productListItems?.reduce((prev, cur) => prev + cur.priceTotal, 0)) || 0
              }
              suffix={currencySymbol}
            />
            <KPI label='PRODUCT VIEWS' value={productViews.length} />
            <KPI label='PURCHASES' value={purchases.length} />
          </>
        )}
      </div>
    </div>
  )

  function KPI({ value, label, suffix }) {
    return (
      <Card allowsSelection={false} className='kpi-entry'>
        <CardBody>
          <div className='kpi-value'>
            <CountUp start={0} end={value} duration={10} separator=',' suffix={suffix} />
          </div>
          <div className='kpi-label'>{label}</div>
        </CardBody>
      </Card>
    )
  }
}

ActivitySummary.requiresLaunch = false
